import { JackpotLevel } from "../singlegame/singlegame_api";
import { GetOrientation, Orientation } from "./FitScreen";
import { IJackpotDisplayResponsive } from "./IJackpotDisplayPIXIAPPResponsive";
import { JackpotDisplayDiamondPotResponsivePIXIAPP } from "./JackpotDisplayDiamondPotResponsivePIXIAPP";
import { Scale } from "./MyHelpers";
import { AtlasResource } from "./ResourceManager/AtlasResource";
import { FontResource } from "./ResourceManager/FontResource";
import { DecodedImageResource } from "./ResourceManager/ImageResource";
import { JSONResource } from "./ResourceManager/JSONResource";
import { PixiSpriteResource } from "./ResourceManager/PixiSpriteResource";
import { IWriteOnlyResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import * as PIXI from 'pixi.js'

export class JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal extends JackpotDisplayDiamondPotResponsivePIXIAPP {
    public override TitleHide() {
        // throw new Error("Method not implemented.");
    }
    public override TitleShow() {
        // throw new Error("Method not implemented.");
    }
    public override StartAnimations(): void {
        // throw new Error("Method not implemented.");
    }
    public override StopAnimations(): void {
        // throw new Error("Method not implemented.");
    }
    public override View(): HTMLElement {
        return null;
        // throw new Error("Method not implemented.");
    }
    public override Update(): void {
        this.canvasTextureJP4Value?.texture?.update();

        this.canvasTextureJP3Value?.texture?.update();

        this.canvasTextureJP2Value?.texture?.update();
        this.canvasTextureJP1Value?.texture?.update();
        this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();

        this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();

        this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
        this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();

        this.OnUpdateAppCallback?.();
    }

    protected override async PrepareResourcesGamePreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        // await super.PrepareResourcesGamePreload(resourceManager);
        // resourceManager.Add(new SpriteResource(this.jackpot + "JackpotsResources-Slider/" + this.jackpotName + "/1Screen/titleJackpotDisplay", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
        // resourceManager.Add(new PixiSpriteResource(this.basepath + "title_sprite2", this.resid.Add("gamename"), true, this.logGroup.Add("gamename"), true));
        resourceManager.Add(new DecodedImageResource(this.basepath + `title.png`, this.resid.ScopedResourceName(["gamename"])));
        
        resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotsResources-Slider/${this.jackpotName}/1Screen/titleJackpotDisplay.png`, this.resid.ScopedResourceName(["title", "image"])));
        resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/FrameJP4.png`, this.resid.ScopedResourceName(["jp4", "image"])));
        resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/FrameJP3.png`, this.resid.ScopedResourceName(["jp3", "image"])));
        resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/FrameJP2.png`, this.resid.ScopedResourceName(["jp2", "image"])));
        resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/FrameJP1.png`, this.resid.ScopedResourceName(["jp1", "image"])));
        //resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/DRAGON-JACKPOT-NAME.png", this.resid.ScopedResourceName(["DragonJackpotName"])));		
        resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));

        resourceManager.Add(new JSONResource(`${this.jackpot}JackpotDisplay${this.jackpotName}/TitleSpine/1Screen/JackpotTitle.json`, this.resid.ScopedResourceName(`JackpotTitleSpineJson`)));
        resourceManager.Add(new AtlasResource(`${this.jackpot}JackpotDisplay${this.jackpotName}/TitleSpine/1Screen/JackpotTitle.atlas`, this.resid.ScopedResourceName(`JackpotTitleSpineAtlas`)));

    }

    protected override async CreatejackpotFrames() {

        this.JP4Background = new PIXI.Sprite(PIXI.Texture.from(this.jp4Img.DecodedImage()));
        this.JP4Background.name = 'JP4-Image';
        this.JP3Background = new PIXI.Sprite(PIXI.Texture.from(this.jp3Img.DecodedImage()));
        this.JP3Background.name = 'JP3-Image';
        this.JP2Background = new PIXI.Sprite(PIXI.Texture.from(this.jp2Img.DecodedImage()));
        this.JP2Background.name = 'JP2-Image';
        this.JP1Background = new PIXI.Sprite(PIXI.Texture.from(this.jp1Img.DecodedImage()));
        this.JP1Background.name = 'JP1-Image';
        // this.titleSpriteAnim = new PIXI.Sprite(PIXI.Texture.from(this.titleImg.DecodedImage()));
        // this.titleSpriteAnim.name = 'title-Image';
        const gameTexture = PIXI.Texture.from(this.gameSprite.DecodedImage());
        gameTexture.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR; // Smooth scaling
        gameTexture.baseTexture.mipmap = PIXI.MIPMAP_MODES.ON; // Better downscaling
        this.gameTitleSprite = new PIXI.Sprite(gameTexture);

        this.gameTitleSprite.name = 'game-title-Image';

        let textureCanvasJP4 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp4].CanvasView().Canvas());
        this.canvasTextureJP4Value = new PIXI.Sprite(textureCanvasJP4);
        this.canvasTextureJP4Value.name = 'JP4-text';

        this.jp4Container = new PIXI.Container();
        this.jp4Container.name = 'jp4-container';
        // this.canvasTextureJP4Value.scale.set(1.5);

        let textureCanvasJP3 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp3].CanvasView().Canvas());
        this.canvasTextureJP3Value = new PIXI.Sprite(textureCanvasJP3);
        this.canvasTextureJP3Value.name = 'JP3-text';
        // this.canvasTextureJP3Value.scale.set(1.5);

        let textureCanvasJP2 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp2].CanvasView().Canvas());
        this.canvasTextureJP2Value = new PIXI.Sprite(textureCanvasJP2);
        this.canvasTextureJP2Value.name = 'JP2-text';
        // this.canvasTextureJP2Value.scale.set(1.5);


        let textureCanvasJP1 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp1].CanvasView().Canvas());
        this.canvasTextureJP1Value = new PIXI.Sprite(textureCanvasJP1);
        this.canvasTextureJP1Value.name = 'JP1-text';
        // this.canvasTextureJP1Value.scale.set(1.5);

    }

    protected override CreateJackpotView(): void {

        this.jp4Container = new PIXI.Container();
        this.jp4Container.name = 'jp4-container';
        this.jackpotContainer.addChild(this.jp4Container);

        this.jp4Container.addChild(this.JP4Background, this.canvasTextureJP4Value);
        this.canvasTextureJP4Value.pivot.set(this.canvasTextureJP4Value.width / 2, this.canvasTextureJP4Value.height / 2);
        this.canvasTextureJP4Value.scale.set(1.2);

        this.canvasTextureJP4Value.position.x = this.JP4Background.width / 2;
        this.canvasTextureJP4Value.position.y = this.jp4Container.height / 2

        this.jp3Container = new PIXI.Container();
        this.jp3Container.name = 'jp3-container';
        this.jackpotContainer.addChild(this.jp3Container);

        this.jp3Container.addChild(this.JP3Background, this.canvasTextureJP3Value);
        this.canvasTextureJP3Value.pivot.set(this.canvasTextureJP3Value.width / 2, this.canvasTextureJP3Value.height / 2);

        this.canvasTextureJP3Value.position.x = this.JP3Background.width / 2;
        this.canvasTextureJP3Value.position.y = this.jp3Container.height / 2

        this.jp2Container = new PIXI.Container();
        this.jp2Container.name = 'jp2-container';
        this.jackpotContainer.addChild(this.jp2Container);

        this.jp2Container.addChild(this.JP2Background, this.canvasTextureJP2Value);
        this.canvasTextureJP2Value.pivot.set(this.canvasTextureJP2Value.width / 2, this.canvasTextureJP2Value.height / 2);

        this.canvasTextureJP2Value.position.x = this.JP2Background.width / 2;
        this.canvasTextureJP2Value.position.y = this.jp2Container.height / 2

        this.jp1Container = new PIXI.Container();
        this.jp1Container.name = 'jp1-container';
        this.jackpotContainer.addChild(this.jp1Container);

        this.jp1Container.addChild(this.JP1Background, this.canvasTextureJP1Value);

        this.canvasTextureJP1Value.pivot.set(this.canvasTextureJP1Value.width / 2, this.canvasTextureJP1Value.height / 2);
        this.canvasTextureJP1Value.position.x = this.JP1Background.width / 2;
        this.canvasTextureJP1Value.position.y = this.jp1Container.height / 2

        this.jpTitleContainer = new PIXI.Container();
        this.jpTitleContainer.name = 'title-container';
        this.jackpotContainer.addChild(this.jpTitleContainer);

        this.jpTitleContainer.addChild(this.gameTitleSprite);

		this.gameTitleSprite.pivot.set(this.gameTitleSprite.width / 2, this.gameTitleSprite.height / 2);
		// this.gameTitleSprite.scale.set(0.25)
		this.gameTitleSprite.position.x = this.jpTitleContainer.width / 2
		this.gameTitleSprite.position.y = this.jpTitleContainer.height / 2
    }

    // protected override ScaleGame(): void {
    //     this.SetToDefault();

    //     if (GetOrientation() == Orientation.Landscape) {

    //         const jackpotNames = ["jp4-container", "jp3-container", "jp2-container", "jp1-container", "title-container"];
    //         const elements = jackpotNames
    //             .map(name => this.jackpotContainer.children.find(child => child.name === name) as PIXI.Container)
    //             .filter(Boolean);

    //         const count = elements.length;
    //         if (count === 0) return;

    //         const availableWidth = this.responsiveView.availableWidth;
    //         const availableHeight = this.responsiveView.availableHeight * this.jackpotContainer.percentHeight;
    //         //const maxElementWidth = Math.max(...elements.map(e => e.width));
    //         const singleGap = Scale.X(30);
    //         const totalGap = singleGap * (count - 1);

    //         const elemWidth = (availableWidth * 0.9 - totalGap) / jackpotNames.length;
    //         //let maxWidthForElements = availableWidth - totalGap;
    //         //let scale = Math.min(1, maxWidthForElements / (maxElementWidth * count));
    //         //
    //         //if (scale > 0.7) scale = 0.7;
    //         //if (scale < 0.2) scale = 0.2;

    //         const totalWidth = elements.map(el => {
    //             const scalex = elemWidth / el.width;
    //             const scaley = availableHeight / el.height;
    //             const scale = Math.min(scalex, scaley);

    //             const scaledWidth = el.width * scale;
    //             return scaledWidth;
    //         })
    //             // sum
    //             .reduce((a, b) => a + b, 0);

    //         let currentX = (availableWidth - totalWidth) / 2;
    //         for (let i = 0; i < elements.length; i++) {
    //             const el = elements[i];


    //             const scalex = elemWidth / el.width;
    //             const scaley = availableHeight / el.height;
    //             const scale = Math.min(scalex, scaley);

    //             const scaledWidth = el.width * scale;

    //             //el.width = elemWidth;
    //             el.scale.set(scale);
    //             el.position.x = currentX;
    //             el.position.y = 0;
    //             currentX += scaledWidth;
    //         }
    //     } else {

    //         const elemWidth = this.responsiveView.availableWidth;
    //         const elemHeight = this.responsiveView.availableHeight * 0.33 / 3;

    //         {
    //             const row1Y = 0;

    //             const row1Width = elemWidth;
    //             const row1Height = elemHeight * 1.1;

    //             const jp4width = this.jp4Container.width;
    //             const scaleX = row1Width / jp4width;
    //             const scaleY = row1Height / this.jp4Container.height;
    //             const scale = Math.min(scaleX, scaleY);



    //             this.jp4Container.scale.set(scale);
    //             this.jp4Container.position.x = (this.responsiveView.availableWidth - (jp4width * scale)) / 2;
    //             this.jp4Container.position.y = row1Y;

    //         }
    //         {
    //             const row2Y = elemHeight;

    //             const row2Width = elemWidth;
    //             const row2Height = elemHeight * 0.9;

    //             const jp3width = this.jp3Container.width;
    //             const scaleX = row2Width / jp3width;
    //             const scaleY = row2Height / this.jp3Container.height;
    //             const scale = Math.min(scaleX, scaleY);

    //             this.jp3Container.scale.set(scale);
    //             this.jp3Container.position.x = (this.responsiveView.availableWidth - (jp3width * scale)) / 2;
    //             this.jp3Container.position.y = row2Y;
    //         }
    //         {

    //             const row3Y = elemHeight * 2;

    //             const row3Width = elemWidth;
    //             const row3Height = elemHeight;


    //             const scaleXJp1 = row3Width / 3 / this.jp1Container.width;
    //             const scaleYJp1 = row3Height / this.jp1Container.height;
    //             const scaleJp1 = Math.min(scaleXJp1, scaleYJp1);


    //             this.jp1Container.scale.set(scaleJp1);
    //             this.jp1Container.position.x = 0;
    //             this.jp1Container.position.y = row3Y;

    //             const scaleXTitle = row3Width / 3 / this.jpTitleContainer.width;
    //             const scaleYTitle = row3Height / this.jpTitleContainer.height;
    //             const scaleTitle = Math.min(scaleXTitle, scaleYTitle);

    //             this.jpTitleContainer.scale.set(scaleTitle);
    //             this.jpTitleContainer.position.x = this.responsiveView.availableWidth / 3;
    //             this.jpTitleContainer.position.y = row3Y;

    //             const scaleXJp2 = row3Width / 3 / this.jp2Container.width;
    //             const scaleYJp2 = row3Height / this.jp2Container.height;
    //             const scaleJp2 = Math.min(scaleXJp2, scaleYJp2);

    //             this.jp2Container.scale.set(scaleJp2);
    //             this.jp2Container.position.x = this.responsiveView.availableWidth / 3 * 2;
    //             this.jp2Container.position.y = row3Y;
    //         }


    //     }


    // }

}